module.exports = __webpack_public_path__ + "static/img/logo@2x.d86b2728.png";